module.exports = __webpack_public_path__ + "img/ring_g_e_0_null@2x.bb12a334.png";